import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import { AuthBox, useAfterLogin, usePublicConfig } from './Auth';
import { t, tError } from '../i18n';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [params] = useSearchParams();
  const afterLogin = useAfterLogin();
  const cfg = usePublicConfig();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const res = await api.post('/api/login', { username, password });
      await afterLogin(res, params.get('return'));
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthBox subtitle={t('Log in to your account.')} onSubmit={submit}>
      {params.get('reset') && <div className="alert ok">{t('Your password was changed. Log in with the new one.')}</div>}
      {error && <div className="alert error">{tError(error)}</div>}
      <label>
        {t('Username or e-mail')}
        <input autoFocus value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" />
      </label>
      <label>
        {t('Password')}
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
      </label>
      <button className="primary" disabled={busy || !username || !password}>
        {busy ? t('Logging in…') : t('Log in')}
      </button>
      <div className="auth-links small">
        <Link to="/forgot-password">{t('Forgot password?')}</Link>
        {cfg.data?.signup_enabled !== false && (
          <span>
            {t('New here?')} <Link to="/signup">{t('Create an account')}</Link>
          </span>
        )}
      </div>
    </AuthBox>
  );
}
